var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRvParkMarker(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 63,
    viewBox: "0 0 58 63",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dd_2054_1028)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.4082 5C10.9736 5 9 6.9736 9 9.40816V40.5918C9 43.0264 10.9736 45 13.4082 45H25.1509L27.0911 48.3605C27.9395 49.8299 30.0603 49.8299 30.9087 48.3605L32.8489 45H44.5918C47.0264 45 49 43.0264 49 40.5918V9.40816C49 6.9736 47.0264 5 44.5918 5H13.4082Z",
    fill: "#FF00BF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.6666 19.6667H42.3333V17L39.6666 14.3333H16.9999C16.2927 14.3333 15.6144 14.6143 15.1143 15.1144C14.6142 15.6145 14.3333 16.2928 14.3333 17V29C14.3333 29.7072 14.6142 30.3855 15.1143 30.8856C15.6144 31.3857 16.2927 31.6667 16.9999 31.6667H18.3333C18.3333 32.7275 18.7547 33.7449 19.5048 34.4951C20.255 35.2452 21.2724 35.6667 22.3333 35.6667C23.3941 35.6667 24.4115 35.2452 25.1617 34.4951C25.9118 33.7449 26.3333 32.7275 26.3333 31.6667H32.9999C32.9999 32.7275 33.4213 33.7449 34.1715 34.4951C34.9216 35.2452 35.9391 35.6667 36.9999 35.6667C38.0608 35.6667 39.0782 35.2452 39.8283 34.4951C40.5785 33.7449 40.9999 32.7275 40.9999 31.6667H43.6666V25M22.3333 33.6667C21.8028 33.6667 21.2941 33.4559 20.919 33.0809C20.544 32.7058 20.3333 32.1971 20.3333 31.6667C20.3333 31.1362 20.544 30.6275 20.919 30.2524C21.2941 29.8774 21.8028 29.6667 22.3333 29.6667C22.8637 29.6667 23.3724 29.8774 23.7475 30.2524C24.1225 30.6275 24.3333 31.1362 24.3333 31.6667C24.3333 32.1971 24.1225 32.7058 23.7475 33.0809C23.3724 33.4559 22.8637 33.6667 22.3333 33.6667ZM24.9999 25H16.9999V21H24.9999M31.6666 29H27.6666V21H31.6666M36.9999 33.6667C36.6044 33.6667 36.2177 33.5494 35.8888 33.3296C35.5599 33.1098 35.3035 32.7975 35.1522 32.432C35.0008 32.0666 34.9612 31.6644 35.0383 31.2765C35.1155 30.8885 35.306 30.5322 35.5857 30.2524C35.8654 29.9727 36.2218 29.7823 36.6097 29.7051C36.9977 29.6279 37.3998 29.6675 37.7653 29.8189C38.1307 29.9703 38.4431 30.2266 38.6629 30.5555C38.8826 30.8844 38.9999 31.2711 38.9999 31.6667C38.9864 32.1928 38.7714 32.6937 38.3992 33.0659C38.027 33.4381 37.5261 33.6532 36.9999 33.6667ZM35.6666 25V21.6667H38.9999L41.6666 25H35.6666Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dd_2054_1028",
    x: 0.183673,
    y: 0.591836,
    width: 57.6327,
    height: 64.2993,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4.40816
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.40816
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.24 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2054_1028"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4.40816
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.40816
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.04 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_2054_1028",
    result: "effect2_dropShadow_2054_1028"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_2054_1028",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRvParkMarker);
export default __webpack_public_path__ + "static/media/rv_park_marker.4418b49430bc6b90e40c44b58cfa78ad.svg";
export { ForwardRef as ReactComponent };